<template>
  <router-view />
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import Swal from "sweetalert2";
import { useLoginStore } from "@/store/loginStore";



const loginStore = useLoginStore();
let intervalId = null;
const idleLimit = 6 * 60 * 60 * 1000; // 6 ساعت به میلی‌ثانیه
const checkInterval = 5 * 60 * 1000;  // 5 دقیقه به میلی‌ثانیه
const warningTime = 30 * 1000;        // 30 ثانیه هشدار
const isAlertOpen = ref(false);

const updateActivity = () => {
  loginStore.updateLastActivity();
};

const checkInactivity = () => {
  const last = loginStore.getLastActivity();
  const now = new Date().getTime();

  if (now - last > idleLimit && !isAlertOpen.value) {
    isAlertOpen.value = true;
    Swal.fire({
      title: "فعالیتی ثبت نشده",
      text: "برای امنیت بیشتر از سیستم خارج می‌شوید.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "خروج",
      cancelButtonText: "ادامه فعالیت",
      timer: warningTime,
      timerProgressBar: true,
    }).then((result) => {
      isAlertOpen.value = false;
      if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
        loginStore.autoLogout("بی‌تحرکی");
      } else {
        loginStore.updateLastActivity();
      }
    });
  }
};

window.addEventListener("storage", (event) => {
  if (event.key === "forceLogout" && event.newValue === "1") {
    loginStore.handleLogout();
  }
});

onMounted(() => {
  const events = ["keydown", "click", "scroll", "touchstart"];
  events.forEach((e) => window.addEventListener(e, updateActivity));
  loginStore.updateLastActivity();
  intervalId = setInterval(checkInactivity, checkInterval);
});

onUnmounted(() => {
  const events = ["keydown", "click", "scroll", "touchstart"];
  events.forEach((e) => window.removeEventListener(e, updateActivity));
  clearInterval(intervalId);
});

</script>


<!-- <template>
  <UpdatePage v-if="isUpdating" />
  <router-view v-else />
</template>

<script setup>
import { ref, onMounted } from 'vue';
import UpdatePage from './components/UpdatePage.vue';

const isUpdating = ref(false);

onMounted(async () => {
  try {
    const res = await fetch('/api/status');
    const data = await res.json();
    if (data.maintenance === true) {
      isUpdating.value = true;
    }
  } catch (e) {
    isUpdating.value = false;
  }
});
</script> -->
